import { FormField, FormFieldType } from '@/models/customizationModels';
import { AmbaInputTypes } from '@/models/globalModels';

export const getInputType = (field: FormField): AmbaInputTypes => {
  if (field.isEmail) return AmbaInputTypes.EMAIL;
  else if (field.isPassword) return AmbaInputTypes.PASSWORD;
  else if (field.isNumber) return AmbaInputTypes.NUMBER;
  else if (field.fieldType === FormFieldType.DATE) return AmbaInputTypes.DATE;
  return AmbaInputTypes.TEXT;
};
